export class ContinuousSliderHTMLElement extends HTMLElement {
    private _container: HTMLElement;
    private isInEditMode: boolean;
    private resizeTimeout: any;
    private windowWidth: number;

    get container() {
        if (!this._container) {
            this._container = this.querySelector('.slider__container');
        }
        return this._container;
    }

    static get observedAttributes(): string[] {
        return ['data-edit-mode', 'data-items-total'];
    }

    public attributeChangedCallback(name: string, oldValue: string, newValue: string): void {
        if (!['data-edit-mode', 'data-items-total'].includes(name)) {
            return;
        }

        if (oldValue === newValue) {
            return;
        }

        switch (name) {
            case 'data-edit-mode':
                this.isInEditMode = newValue === 'true';
                if (newValue !== 'true') {
                    this.multiplyContent();
                }
                if (oldValue !== 'true') {
                    const cont = this.container;
                    cont.style.setProperty('--slide-value', '0');
                    while (cont.childElementCount > 1) {
                        cont.removeChild(cont.lastChild);
                    }
                }
                break;
            case 'data-items-total':
                if (!this.isInEditMode) {
                    this.multiplyContent();
                }
                break;
        }
    }

    private doSlide(direction: 'back' | 'forward'): void {
        let scrollValue = Number(getComputedStyle(this.container).getPropertyValue('--slide-value'));
        if (direction === 'back') {
            scrollValue++;
        } else {
            scrollValue--;
        }
        this.container.style.setProperty('--slide-value', scrollValue.toString());
    }

    private multiplyContent(): void {
        setTimeout(() => {
            const cont = this.container;
            cont.style.setProperty('--slide-value', '0');
            const availableWidth = this.clientWidth;
            const contentWith = cont.firstElementChild.clientWidth; // px
            let offset: string;
            if (contentWith < availableWidth) { // if it should not scroll
                offset = '0';
                while (cont.childElementCount > 1) {
                    cont.removeChild(cont.lastElementChild);
                }
            } else {
                offset = 'calc(-50% - 20px)'; // 100% / n,  20px gutter, n = n slides
                if (cont.childElementCount === 1) {
                    cont.appendChild(cont.lastElementChild.cloneNode(true));
                }
            }
            const v = 100; // px/s
            const t = contentWith / v; // s
            cont.style.setProperty('--continuous-slider-width', offset);
            cont.style.setProperty('--continuous-slider-animation-time', `${t}s`);
        });
    }

    private resize = () => {
        if (this.windowWidth === window.innerWidth) {
            return;
        }
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = setTimeout(() => {
            !this.isInEditMode && this.multiplyContent();
            this.windowWidth = window.innerWidth;
        }, 100);
    }
    public connectedCallback(): void {
        const element = <HTMLElement>this;

        window.addEventListener('resize', this.resize);
        this.windowWidth = window.innerWidth;

        element.addEventListener('click', oEvent => {
            const clickElement = oEvent.composedPath()[0] as HTMLElement;
            if (clickElement.closest('.slider__prev')) {
                this.doSlide('back');
            } else if (clickElement.closest('.slider__next')) {
                this.doSlide('forward');
            }
        });
        this.resize();
    }

    public disconnectedCallback(): void {
        window.removeEventListener('resize', this.resize);
    }
}